import { render, staticRenderFns } from "./floatWindow.vue?vue&type=template&id=6b5f0f78&scoped=true"
import script from "./floatWindow.vue?vue&type=script&lang=js"
export * from "./floatWindow.vue?vue&type=script&lang=js"
import style0 from "./floatWindow.vue?vue&type=style&index=0&id=6b5f0f78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5f0f78",
  null
  
)

export default component.exports